import React from "react";
import PropTypes from "prop-types";

import { Icon } from "semantic-ui-react";

import CardLayout from "./CardLayout";

export function DefaultCard({
  onMouseEnter,
  onMouseLeave,
  title,
  numWorkflows,
  publishingName,
  faviconUrl,
}) {
  return (
    <CardLayout
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      header={
        <React.Fragment>
          {faviconUrl && (
            <img
              style={{ height: "16px", width: "16px", marginRight: "1em" }}
              src={faviconUrl}
              alt="Template owner logo"
              data-test="publisher-favicon"
            />
          )}
          <span style={{ fontSize: "12px" }} data-test="publisher-name">
            {publishingName}
          </span>
        </React.Fragment>
      }
      descriptionStyle={{ paddingTop: "1.5em" }}
      description={
        <span
          style={{
            fontSize: "18px",
            color: "black",
            display: "-webkit-box",
            overflow: "hidden",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: "3",
            lineHeight: "1.2em",
          }}
        >
          {title}
        </span>
      }
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          position: "absolute",
          bottom: "0",
          marginBottom: "1em",
        }}
      >
        <Icon
          name="align left"
          color="black"
          style={{ transform: "rotate(90deg)" }}
        />
        <span style={{ color: "black", fontWeight: "bold", fontSize: "12px" }}>
          {numWorkflows
            ? `${numWorkflows} Workflow${numWorkflows > 1 ? "s" : ""}`
            : ""}
        </span>
      </div>
    </CardLayout>
  );
}

DefaultCard.propTypes = {
  onMouseEnter: PropTypes.func.isRequired,
  onMouseLeave: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  numWorkflows: PropTypes.number,
  publishingName: PropTypes.string.isRequired,
  faviconUrl: PropTypes.string.isRequired,
};

DefaultCard.defaultProps = {
  numWorkflows: null,
};

export default DefaultCard;
